// react
import React from "react";
import Editor from "@react-page/editor";
import { imagePlugin } from "@react-page/plugins-image";
import slate from "@react-page/plugins-slate";
import background from "@react-page/plugins-background";
import video from "@react-page/plugins-video";
import divider from "@react-page/plugins-divider";
import spacer from "@react-page/plugins-spacer";

function ProductTabContent(props) {
    const { content } = props;
    const cellPlugins = [slate(), video, divider, spacer, imagePlugin(), background()];
    return (
        <div>
            <Editor value={content} cellPlugins={cellPlugins} readOnly />
        </div>
    );
}

export default ProductTabContent;
